<template>
  <div class="app-container">
    <!-- 搜索表单 -->
    <el-form :model="queryParams" ref="queryForm" v-show="showSearch" label-width="100px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="8">
          <el-form-item label="状态" prop="statusList">
            <el-select v-model="queryParams.statusList" placeholder="请选择状态" clearable multiple style="width:100%">
              <el-option label="计划中" value="planning"/>
              <el-option label="执行中" value="executing"/>
              <el-option label="已完成" value="completed"/>
              <el-option label="已暂停" value="paused"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 工具栏 -->
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="danger" icon="el-icon-delete" :disabled="multiple" @click="handleBatchDelete">删除</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <!-- 数据表格 -->
    <el-table v-loading="loading" :data="dataList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"/>
      <el-table-column label="时间" width="170" align="center" prop="time"/>
      <el-table-column label="内容" min-width="200" align="left" show-overflow-tooltip prop="content"/>
      <el-table-column label="状态" width="100" align="center" prop="status">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'planning'" type="info">计划中</el-tag>
          <el-tag v-else-if="scope.row.status === 'executing'" type="warning">执行中</el-tag>
          <el-tag v-else-if="scope.row.status === 'completed'" type="success">已完成</el-tag>
          <el-tag v-else-if="scope.row.status === 'paused'" type="danger">已暂停</el-tag>
          <span v-else>{{ scope.row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建人" width="100" align="center" prop="createByUserName"/>
      <el-table-column label="创建时间" width="170" align="center" prop="createTime"/>
      <el-table-column label="操作" width="120" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>

    <!-- 新增/编辑对话框 -->
    <SafetyPlanDialog ref="safetyPlanDialogRef" @success="getList"></SafetyPlanDialog>
  </div>
</template>

<script>
import {querySafetyPlanList, deleteSafetyPlan} from "@/api/crm/safetyPlan";
import SafetyPlanDialog from "./components/SafetyPlanDialog";

export default {
  name: "SafetyPlanManage",
  components: {
    SafetyPlanDialog
  },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 数据列表
      dataList: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        statusList: []
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 获取列表数据 */
    getList() {
      this.loading = true;
      querySafetyPlanList(this.queryParams).then(response => {
        this.dataList = response.rows || [];
        this.total = response.total;
        this.loading = false;
      }).catch(error => {
        this.loading = false;
      });
    },
    
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    
    /** 多选框选中数据 */
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.multiple = !selection.length;
    },
    
    /** 新增按钮操作 */
    handleAdd() {
      this.$refs.safetyPlanDialogRef.openDialog();
    },
    
    /** 编辑按钮操作 */
    handleEdit(row) {
      this.$refs.safetyPlanDialogRef.openDialog(row.id);
    },
    
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm('确认删除该安全环保计划吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSafetyPlan({id: row.id}).then(() => {
          this.$message.success('删除成功');
          this.getList();
        });
      });
    },
    
    /** 批量删除操作 */
    handleBatchDelete() {
      if (this.ids.length === 0) {
        this.$message.warning('请选择要删除的数据');
        return;
      }
      
      this.$confirm('确认删除选中的安全环保计划吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const deletePromises = this.ids.map(id => deleteSafetyPlan({id}));
        Promise.all(deletePromises).then(() => {
          this.$message.success('删除成功');
          this.getList();
        });
      });
    }
  }
};
</script>